
const DisplayBox = function (props) {

	var displayClass ="";
	
	if ( props.display !== undefined) {
		displayClass = props.display !== null ? 'show fade-in' : 'hide fade-out' ;
	}

	return <div className={displayClass} >
		{props.children}
	</div>
		
};

export  {DisplayBox};